module.exports = __webpack_public_path__ + "static/media/is-fav.6a0b8317.svg";